import get from 'lodash/get';
import { types } from 'src/common/utils/guideItemTypes';

export default function mapCategoryResponse(data, guideId) {
  return {
    guideId,
    type: types.category,
    title: get(data, 'header.title', ''),
    imageUrl: get(data, 'header.imageUrl', ''),
    containerItems: data.items,
    metadata: data.metadata,
  };
}
